export enum MapType {
  SisMap = 0,
  Windmonitor = 1
}
